<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog"
        title="撤回实施人员"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <el-form
                ref="workOrderProcessingUserRevokeForm"
                :model="workOrderProcessingUserRevokeForm"
                :rules="workOrderProcessingUserRevokeFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="撤回实施人" prop="processing_uids">
                    <el-select
                        placeholder="请选择"
                        multiple
                        filterable
                        collapse-tags
                        v-model="workOrderProcessingUserRevokeForm.processing_uids"
                    >
                        <el-option
                            :disabled="user.status === 3"
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                            v-for="user in processingUserSelectedList"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { revokeProcessing } from "@/api";
export default {
    name: "WorkOrderProcessinguserRevoke",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        // 已经选择过的实施人员
        processing_users_selected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
            workOrderProcessingUserRevokeForm: {
                processing_uids: [],
            },
            workOrderProcessingUserRevokeFormRules: {},
            processingUserSelectedList: [],
        };
    },
    created() {
        this.processingUserSelectedList = this.processing_users_selected.map((item) => {
            return {...item.processing_user, status: item.status};
        });
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderProcessingUserRevokeForm.validate((valid) => {
                if (valid) {
                    if (!this.workOrderProcessingUserRevokeForm.processing_uids.length) return;
                    const params = {
                        workorder_id: this.workorder_id,
                        processing_uids: this.workOrderProcessingUserRevokeForm.processing_uids,
                    };
                    revokeProcessing(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message || "提交成功");
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
